import jsPDF from "jspdf";

export interface CaixaLogo {
    x: number;
    y: number;
    largura: number;
    altura: number;
    alinhar?: "esquerda" | "direita";
}

const dimensoesDaImagem = (pdf: jsPDF, imagem: HTMLImageElement | string) => {
    if (typeof imagem === "string") {
        const props = pdf.getImageProperties(imagem);
        return { largura: props.width, altura: props.height, formato: props.fileType || "PNG" };
    }
    return { largura: imagem.naturalWidth || imagem.width, altura: imagem.naturalHeight || imagem.height, formato: "PNG" };
};

export const adicionarLogo = (pdf: jsPDF, imagem: HTMLImageElement | string, caixa: CaixaLogo) => {
    const img = dimensoesDaImagem(pdf, imagem);
    let largura = caixa.largura;
    let altura = caixa.altura;
    if (img.largura > 0 && img.altura > 0) {
        const escala = Math.min(caixa.largura / img.largura, caixa.altura / img.altura);
        largura = img.largura * escala;
        altura = img.altura * escala;
    }
    const x = caixa.alinhar === "direita" ? caixa.x + caixa.largura - largura : caixa.x;
    pdf.addImage(imagem, img.formato, x, caixa.y, largura, altura);
    return { largura, altura };
};
